import { useTranslation } from 'react-i18next'

import { SlidersHorizontalIcon, XIcon } from '@phosphor-icons/react'

import { Button, SegmentedControls, Switch, Text } from '@reveni-io/reveni-ui'

import {
  previewModeOptions,
  previewModes,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'

import CustomScenarioSettings from './CustomScenarioSettings/CustomScenarioSettings'
import RealOrderSettings from './RealOrderSettings/RealOrderSettings'
import { showHiddenBlocksDescriptions } from './constants'
import * as Styles from './styles'

const PreviewSettingsSidebar = ({
  previewMode,
  onChangePreviewMode,
  showHiddenBlocks,
  onChangeShowHiddenBlocks,
  scenarioItems,
  scenarioShipments,
  scenarioReturnRequests,
  scenarioPreviewDate,
  scenarioCriteria,
  storeId,
  timeZone,
  selectedRealOrderId,
  selectedRealOrderName,
  onSelectRealOrder,
  onClose,
}) => {
  const { t } = useTranslation()

  const handleChangeShowHiddenBlocks = event => onChangeShowHiddenBlocks(event.target.checked)

  const hiddenBlocksDescription = showHiddenBlocks
    ? showHiddenBlocksDescriptions.enabled
    : showHiddenBlocksDescriptions.disabled

  const previewModeSegments = previewModeOptions.map(option => ({ id: option.id, label: t(option.label) }))
  const isCustomScenario = previewMode === previewModes.customScenario

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.HeaderLabel type="bodyMRegular">{t('Configuración de la preview')}</Styles.HeaderLabel>
        <Button variant="text" aria-label={t('Cerrar la configuración de la preview')} onClick={onClose}>
          <XIcon size={20} />
        </Button>
      </Styles.Header>
      <Styles.Settings>
        <Styles.Intro>
          <Styles.Title>
            <SlidersHorizontalIcon size={24} />
            <Text type="titleM">{t('Configuración de la preview')}</Text>
          </Styles.Title>
          <Styles.Description type="bodySRegular">
            {t(
              'Configura la fecha de la preview, los datos del pedido y los criterios de visibilidad para simular cómo se ve tu página de seguimiento bajo distintas condiciones.'
            )}
          </Styles.Description>
        </Styles.Intro>
        <Styles.HiddenBlocks>
          <Styles.HiddenBlocksToggle>
            <Text type="bodyMRegular">{t('Mostrar bloques ocultos')}</Text>
            <Switch checked={showHiddenBlocks} onChange={handleChangeShowHiddenBlocks} />
          </Styles.HiddenBlocksToggle>
          <Styles.Description type="bodySRegular">{t(hiddenBlocksDescription)}</Styles.Description>
        </Styles.HiddenBlocks>
      </Styles.Settings>
      <Styles.Modes>
        <SegmentedControls options={previewModeSegments} value={previewMode} onChange={onChangePreviewMode} />
        {isCustomScenario && (
          <CustomScenarioSettings
            scenarioItems={scenarioItems}
            scenarioShipments={scenarioShipments}
            scenarioReturnRequests={scenarioReturnRequests}
            scenarioPreviewDate={scenarioPreviewDate}
            scenarioCriteria={scenarioCriteria}
          />
        )}
        {!isCustomScenario && (
          <RealOrderSettings
            storeId={storeId}
            timeZone={timeZone}
            selectedRealOrderId={selectedRealOrderId}
            selectedRealOrderName={selectedRealOrderName}
            onSelectRealOrder={onSelectRealOrder}
          />
        )}
      </Styles.Modes>
    </Styles.Container>
  )
}

export default PreviewSettingsSidebar
